import React from "react";
import PropTypes from "prop-types";

import { Bar } from "react-chartjs-2";

const EMPTY_CHART_DATA = {
  labels: [],
  datasets: [
    {
      label: "On Time Rate",
      backgroundColor: "#3D49B9",
      borderColor: "#3D49B9",
      hoverBackgroundColor: "#3D49B9",
      hoverBorderColor: "#3D49B9",
      data: []
    }
  ]
};

export const BarChart = ({ data }) => {
  const chartData =
    data && data.datasets ? data : EMPTY_CHART_DATA;

  return (
    <Bar
      data={chartData}
      options={{
        legend: { display: false },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }}
    />
  );
};

BarChart.propTypes = {
  fetchGraph: PropTypes.func,
  data: PropTypes.shape({
    labels: PropTypes.array,
    datasets: PropTypes.array
  }),
  filters: PropTypes.object
};
